var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.currentUser)?_c('div',{staticClass:"topbar"},[_c('a',{staticClass:"topbar__logout",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.signOut($event)}}},[_vm._v(_vm._s(_vm.$t('menu.signout')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa6e888","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Topbar.vue
// module id = 644
// module chunks = 1